import { useTranslation } from 'next-i18next/pages';
import { UserProfileIcon } from '@pkgs/components/assets/icons/medium/UserProfileIcon';
import { Headline } from '@ev-tech/ui-core-components/Headline';
import { Button } from '@ev-tech/ui-core-components/Button';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useUserAcountAuth } from '@/hooks/useUserAcountAuth';

import styles from './PropertyLockedInfoCard.module.css';

export const UAExclusiveLockedInfoCard = (): React.ReactElement => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);

  const { openUserAccountModal } = useUserAcountAuth();

  return (
    <div className={styles.container}>
      <UserProfileIcon />
      <Headline label={t('search.expose.listing.userExclusive.locked.heroImage.title')} as="h1" size="h4" />
      <p className={styles.text}>{t('search.expose.listing.userExclusive.locked.text')}</p>
      <Button
        className={styles.button}
        onClick={() => openUserAccountModal({ triggerId: 'user-account-exclusive-card_tertiary_sign-in' })}
        label={t('search.contact.form.success.signInBanner.button')}
        size="medium"
      />
    </div>
  );
};
